import { message } from "antd";
import type { MessageArgsProps } from "antd";

export { message } from "antd";

export const CommonMessage = {
  success: (content: string | MessageArgsProps) => {
    const config = typeof content === "string" ? { content } : content;
    return message.success({ duration: 2, ...config });
  },
  error: (content: string | MessageArgsProps) => {
    const config = typeof content === "string" ? { content } : content;
    return message.error({ duration: 3, ...config });
  },
  warning: (content: string | MessageArgsProps) => {
    const config = typeof content === "string" ? { content } : content;
    return message.warning({ duration: 2, ...config });
  },
  loading: (content: string | MessageArgsProps) => {
    const config = typeof content === "string" ? { content } : content;
    return message.loading({ content: config.content, duration: 0 });
  },
};
